import { WITHOUT_LABEL } from '../../../features/schema'

export type Schema = typeof schema

export type FormData = {
  prompt: string
  utterance: string
  description: string
  llmChatService: string
  suggestedDescription: string
}

export const DEFAULT_PROMPT_TEXT = `
Uprav následující popis intentu v rámci NLP klasifikátoru tak, aby matchoval i vstup uživatele, který doteď matchnutý nebyl. Zároveň v něm uchovej i původní intent description a nevynechávej žádné informace, které v něm jsou, jen přidej novou.
NEROZPOZNANÝ VSTUP UŽIVATELE:
{{utterance}}

STÁVAJÍCÍ POPIS:
{{#intents}}
{{description}}
{{/intents}}
Buď stručný a vypiš mi pouze text nového “description” bez prefixu a analýzy. Neanalyzuj a nerozebírej původní a nový intent.
`

export const defaultFormData: FormData = {
  utterance: '',
  description: '',
  llmChatService: '',
  suggestedDescription: '',
  prompt: DEFAULT_PROMPT_TEXT
}

export const uiSchema = {
  prompt: { 'ui:widget': 'TextAreaWidget', initialRowsCount: 9, isWrapTextEnabled: true },
  utterance: { 'ui:widget': 'TextAreaWidget', initialRowsCount: 9, isWrapTextEnabled: true },
  description: { 'ui:widget': 'TextAreaWidget', initialRowsCount: 9, isWrapTextEnabled: true },
  testSection: { 'ui:widget': 'TestSectionWidget', ...WITHOUT_LABEL },
  suggestedDescription: {
    'ui:widget': 'SuggestedIntentDescriptionWidget',
    initialRowsCount: 9,
    isWrapTextEnabled: true
  },
  llmChatService: {
    kind: 'llm-chat',
    action: 'Chat model response',
    'ui:widget': 'ServerCloudServiceSelectWidget'
  }
}

export const schema = {
  type: 'object',
  properties: {
    description: {
      type: 'string',
      title: 'This tool allows you to modify current intent description'
    },
    utterance: {
      type: 'string',
      title: 'together with selected unmatched utterance'
    },
    prompt: {
      type: 'string',
      title: 'and suggests modified description which will match it too using this AI prompt'
    },
    llmChatService: {
      type: 'string',
      title: 'and this LLM service.'
    },
    suggestedDescription: {
      type: 'string',
      title: 'Suggested intent description'
    },
    testSection: {
      type: 'string',
      title: 'Test section'
    }
  }
} as const
